import { Button } from 'semantic-ui-react';
import styled, { css } from 'styled-components';
import { theme } from '~/Theme';

const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 0 2.5rem;

  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoint.mobileM}) {
      max-width: 640px;
    }

    @media (min-width: ${theme.breakpoint.tablet}) {
      max-width: 768px;
    }

    @media (min-width: ${theme.breakpoint.laptop}) {
      max-width: 1024px;
    }

    @media (min-width: ${theme.breakpoint.laptopL}) {
      max-width: 1280px;
    }
  `}
`;

const AuthGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  > form .ui.error.message {
    position: absolute;
    left: 0 !important;
    bottom: 0 !important;
  }
`;

const AuthRightSide = styled.div`
  padding-top: 50px;
  border-radius: 15px 50px 30px;
  width: auto;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
`;

const AuthLeftSide = styled.div`
  min-height: 100vh;
  flex-direction: column;
  display: flex;
`;

const PrimaryButton = styled(Button)`
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  padding-top: 0.9rem !important;
  padding-bottom: 0.9rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  color: #ffffff !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  &:hover {
    color: #ffffff !important;
    background-color: ${props => props.theme?.secondColor || 'rgb(26, 49, 117, 0.9)'} !important;
  }
`;

const PrimaryOutlineButton = styled(Button)`
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  font-size: 1rem !important;
  padding-top: 0.9rem !important;
  padding-bottom: 0.9rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  font-size: 0.975rem !important;
  font-weight: 500 !important;
  color: #1a3175 !important;
  border-color: #1a3175 !important;
  background-color: transparent !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  &.mid-size {
    font-size: 0.975rem !important;
  }

  &:hover {
    color: #ffffff !important;
    background-color: rgb(26, 49, 117, 0.9) !important;
  }
`;

const DefaultOutlineButton = styled(Button)`
  font-size: 0.975rem !important;
  padding: 0.9rem 1rem !important;
  border: 1px solid rgb(226 232 240) !important;
  background-color: transparent !important;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  color: rgb(100 116 139) !important;

  > .plus {
    font-size: 1.1rem !important;
    padding-right: 1.6rem !important;
  }

  &.mid-size {
    font-size: 0.875rem;

    > .plus {
      font-size: 1rem !important;
      padding-right: 1.2rem !important;
    }
  }
`;

const DefaultLinkButton = styled(Button)`
  font-size: 0.975rem !important;
  padding: 0.8rem 1rem !important;
  border: none !important;
  background-color: transparent !important;
  color: rgb(100 116 139) !important;

  &.danger {
    color: rgb(185 28 28) !important;

    > .trash {
      color: rgb(185 28 28) !important;
    }
  }

  > .pencil {
    color: rgb(100 116 139) !important;
  }
`;

export const GlobalEl = {
  AuthGrid,
  AuthLeftSide,
  AuthRightSide,
  Container,
  PrimaryButton,
  PrimaryOutlineButton,
  DefaultOutlineButton,
  DefaultLinkButton
};
